//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import notificationMixin from '@/mixins/notificationMixin'
import ProjectTabsAddUsersWithoutMassiveImport from '@/components/Projects/NewProjectSteps/shared/ProjectTabsAddUsersWithoutMassiveImport.vue'
import ProjectActionsContainer from '@/components/Projects/NewProjectSteps/shared/ProjectActionsContainer.vue'
import Button from '@/components/Shared/Button.vue'
import AddNewUserForm from '@/components/Projects/NewProjectSteps/shared/TabNewUsers/AddNewUserForm.vue'
import ProjectModalAddUsers from '~/components/Projects/NewProjectSteps/shared/ProjectModalAddUsers.vue'
import TabAddNewUsersWithoutMassiveImport from '~/components/Projects/NewProjectSteps/shared/TabNewUsers/TabAddNewUsersWithoutMassiveImport.vue'
import TabAddRegisteredUsers from '~/components/Projects/NewProjectSteps/shared/TabRegisteredUsers/TabAddRegisteredUsers.vue'

const SEND_INVITATION = false
const TAB_ADD_REGISTERED_USERS = 0
const TAB_ADD_NEW_USER = 1

export default {
  components: {
    ProjectModalAddUsers,
    ProjectTabsAddUsersWithoutMassiveImport,
    ProjectActionsContainer,
    Button,
    TabAddNewUsersWithoutMassiveImport,
    TabAddRegisteredUsers,
    AddNewUserForm,
  },
  mixins: [handleErrorMixin, notificationMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    employees: {
      type: Array,
      default: () => [],
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isShow: this.value,
      tab: 0,
      isValidForm: false,
      newUserToAdd: null,
      existedUsersToAddIds: [],
      keepOpenAfterSubmit: false,
      addUserFormKey: 0,
      isLoadingForm: false,
    }
  },
  computed: {
    employeesWithStatus() {
      return this.employees.map((employee) => ({
        ...employee,
        isSelectable: this.isSelectableUser(employee),
        tag: this.getUserOptionTab(employee),
      }))
    },
    isEnabledButtonConfirm() {
      return (
        (this.tab === TAB_ADD_REGISTERED_USERS &&
          this.existedUsersToAddIds.length > 0) ||
        (this.tab === TAB_ADD_NEW_USER && this.isValidForm)
      )
    },
  },
  watch: {
    isShow(newValue) {
      this.tab = 0
      this.$emit('input', newValue)
      if (newValue) {
        this.reset()
      }
    },
    value(newValue) {
      this.tab = 0
      this.isShow = newValue
      if (!newValue) {
        this.reset()
      }
    },
  },
  methods: {
    isSelectableUser(user) {
      if (!user.identification_number || !user.email) {
        return false
      }
      return !user.projectRole
    },
    getUserOptionTab(user) {
      if (!user.identification_number) {
        return 'RUT no registrado'
      }

      if (!user.email) {
        return 'Email no registrado'
      }

      if (!user.projectRole) {
        return null
      }
      return user.projectRole.project === this.projectId
        ? 'Pertenece al proyecto'
        : 'Pertenece a otro proyecto'
    },
    reset() {
      this.addUserFormKey += 1
      this.isValidForm = false
      this.newUserToAdd = null
      this.existedUsersToAddIds = []
    },
    handleClickConfirm() {
      if (this.tab === TAB_ADD_REGISTERED_USERS) {
        this.addExistedUsers()
      }
      if (this.tab === TAB_ADD_NEW_USER) {
        this.handleConfirmAddNewUserTab()
      }
    },
    handleClickConfirmAndOther() {
      this.keepOpenAfterSubmit = true
      this.handleConfirmAddNewUserTab()
    },
    async handleConfirmAddNewUserTab() {
      this.isLoadingForm = true
      try {
        await this.saveNewUser()
      } catch (error) {
        this.$emit('user-with-error', error.message)
        this.handleError(error, 'Error al agregar supervisor')
      } finally {
        this.isLoadingForm = false
      }
    },
    getFormatedUser() {
      const user = { ...this.newUserToAdd, project_id: this.projectId }
      delete user.repeatEmail
      if (!user.email) {
        delete user.email
      }
      return user
    },
    handlePostSubmit() {
      this.reset()
      this.$emit('refresh-employees')
      if (!this.keepOpenAfterSubmit) {
        this.isShow = false
      }
      this.keepOpenAfterSubmit = false
    },
    async saveNewUser() {
      const user = this.getFormatedUser()
      await this.$repository.invitation.newSingleCreateSupervisors({
        user,
        projectId: this.projectId,
        sendInvitation: SEND_INVITATION,
      })
      this.successNotification('Supervisor agregado correctamente')
      this.handlePostSubmit()
    },
    async addExistedUsers() {
      try {
        await this.$repository.invitation.addExistingSupervisorsToProjectAndNotify(
          {
            projectId: this.projectId,
            usersIds: this.existedUsersToAddIds,
            sendInvitation: SEND_INVITATION,
          }
        )
        this.successNotification('Supervisores agregados correctamente')
        this.handlePostSubmit()
      } catch (error) {
        this.handleError(error, 'Error al agregar supervisores')
      }
    },
  },
}
